<template>
  <Modal :option="'filter'" @close="handleCancelModal">
    <template v-if="isCategoryModal">
      <div class="p-modal__content__header">
        <div>{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectCategoryModal.title') }}</div>
      </div>
      <div class="p-modal__content__body scrollable">
        <info>
          <p>{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectCategoryModal.info') }}</p>
        </info>
        <div class="categoryBox">
          <div class="categoryBox__header">
            <span class="categoryBox__title">{{ $t('labels.service') }}</span>
          </div>
          <div class="categoryBox__body">
            <ul>
              <li v-for="service in mediaLibraryServices" :key="service.id" class="c-checkbox__item">
                <KkCheckbox
                  :id="service.id"
                  :label="service.name"
                  :model-value="selectServices.includes(service.id)"
                  @update:modelValue="handleServiceCheckbox(service.id)"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="categoryBox">
          <div class="categoryBox__header">
            <span class="categoryBox__title">{{ $t('labels.category') }}</span>
          </div>
          <div class="categoryBox__body">
            <ul class="p-terms__radio">
              <li v-for="category in mediaLibraryCategories" :key="category.id" class="c-radio__item">
                <input :id="category.id"
                       v-model="selectCategory"
                       class="c-radio__input js-companiesAnalysisReviews__crossButton"
                       type="radio"
                       :value="category.id"
                       :disabled="selectCategoryDisabled(category.id)"
                >
                <label class="c-radio__label" :class="{'unselectable': selectCategoryDisabled(category.id)}" :for="category.id">{{ category.name }}</label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="p-modal__content__footer">
        <div class="c-button c-button--right">
          <div class="store-count-wap">{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.targetMediaLibrariesCount') }}<span class="store-count">{{ mediaLibraryIds.length }}</span>{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.mediaLibrariesCountUnit') }}</div>
          <button
            class="c-button__item c-button__item--outline-cancel"
            @click="handleCancelModal"
            v-text="$t('labels.cancel')"
          />
          <button
            class="c-button__item c-button__item--outline-cancel"
            @click="isCategoryModal = false"
            v-text="$t('pages.CompaniesLocationStore.mediaLibraries.SelectCategoryModal.backSelectMediaLibrariesModal')"
          />
          <button
            class="c-button__item c-button__item--primary"
            :disabled="submitButtonDisabled"
            @click="handleSubmit"
            v-text="$t('labels.confirm')"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="p-modal__content__header">
        <div>{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.title') }}</div>
      </div>
      <div class="p-modal__content__body">
        <div class="c-grid">
          <div class="c-grid__items">
            <div class="c-grid__item c-grid__item__s__7 c-grid__item__m__8 c-grid__item__l__9 mediaLibraries">
              <div v-if="mediaLibraries.length == 0" class="noMediaLibraries__description">{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectCategoryModal.noMediaDescription') }}</div>
              <template v-else>
                <div class="c-select">
                  <select :value="sortKey" @change="$emit('change-sort', $event.target.value)">
                    <option :value="null" disabled>{{ $t('labels.placeholder.select') }}</option>
                    <option key="store_count" value="store_count">{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.label.storeCount') }}</option>
                    <option key="created_at" value="created_at">{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.label.createdAt') }}</option>
                    <option key="updated_at" value="updated_at">{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.label.updatedAt') }}</option>
                  </select>
                </div>
                <div v-if="!mediaLibrariesLoading" class="p-photos__items">
                  <div v-for="mediaLibrary in mediaLibraries"
                       :key="mediaLibrary.id"
                       class="p-photos__item"
                  >
                    <div class="p-photos__image" @click="$emit('read-select-media-library', mediaLibrary.id)">
                      <div :style="{ 'background-image': `url(${ mediaLibrary.mediaImageUrl })` }" />
                    </div>
                    <input :id="mediaLibrary.id"
                           type="checkbox"
                           class="c-checkbox__input"
                           :checked="mediaLibraryIds.includes(mediaLibrary.id)"
                           @change="handleChangeMediaLibraryIds(mediaLibrary.id)"
                    >
                    <label
                      class="c-checkbox__label"
                      :for="mediaLibrary.id"
                    >
                      {{ $t('pages.CompaniesMediaLibraries.select') }}
                    </label>
                  </div>
                </div>
              </template>
              <Loading v-show="mediaLibrariesLoading" />
            </div>
            <div class="c-grid__item c-grid__item__s__5 c-grid__item__m__4 c-grid__item__l__3 mediaLibraryDetail">
              <div v-if="selectMediaLibrary && !mediaLibraryLoading">
                <section class="p-box">
                  <div class="p-photos__image">
                    <div :style="{ 'background-image': `url(${ selectMediaLibrary.mediaImageUrl })` }" />
                  </div>
                </section>
                <section class="detail__container">
                  <div>
                    <h3 class="detail__title">
                      {{ $t('pages.CompaniesLocationStoreMediaLibrary.infoTitle') }}
                    </h3>
                    <ul class="value__list">
                      <li class="value__item">{{ $t('models.mediaLibrary.fileName') }}：<span class="value__text">{{ selectMediaLibrary.fileName }}</span></li>
                      <li class="value__item">{{ $t('models.mediaLibrary.fileUploadedAt') }}：<span class="value__text">{{ uploadedTime }}</span></li>
                      <li class="value__item">{{ $t('models.mediaLibrary.fileUploadUser') }}：<span class="value__text">{{ fileUploadUserName }}</span></li>
                      <li class="value__item">{{ $t('models.mediaLibrary.fileSize') }}：<span class="value__text">{{ fileSize }}</span></li>
                    </ul>
                  </div>
                </section>
              </div>
              <Loading v-show="mediaLibraryLoading" />
            </div>
          </div>
        </div>
      </div>
      <div class="p-modal__content__footer">
        <div class="c-button c-button--right">
          <div class="store-count-wap">{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.targetMediaLibrariesCount') }}<span class="store-count">{{ mediaLibraryIds.length }}</span>{{ $t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.mediaLibrariesCountUnit') }}</div>
          <button
            class="c-button__item c-button__item--outline-cancel"
            @click="handleCancelModal"
            v-text="$t('labels.cancel')"
          />
          <button
            class="c-button__item c-button__item--primary"
            :disabled="mediaLibraryIds.length === 0"
            @click="handleSelectCategory"
            v-text="$t('pages.CompaniesLocationStore.mediaLibraries.SelectMediaLibrariesModal.selectServiceAndCategory')"
          />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { validate } from 'vee-validate'
import Modal from '../Modal'
import Info from '../Info'
import { basicDateFormat } from '../../modules/date'
import { mediaLibraryCategoriesConst } from '../../modules/mediaLibraryCategoriesConst'
import { mediaLibraryServicesConst } from '../../domains/mediaLibrary/consts'
import Loading from '../Loading'
import { KkCheckbox } from '../../components/base'

export default {
  name: 'SelectMediaLibrariesModal',
  components: {
    Modal,
    Info,
    Loading,
    KkCheckbox
  },
  props: {
    mediaLibraries: {
      type: Array,
      required: true
    },
    selectMediaLibrary: {
      type: Object,
      default: null
    },
    mediaLibraryLoading: {
      type: Boolean,
      required: true
    },
    mediaLibrariesLoading: {
      type: Boolean,
      required: true
    },
    sortKey: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'submit', 'read-select-media-library', 'change-sort'],
  data() {
    return {
      mediaLibraryIds: [],
      isCategoryModal: false,
      selectCategory: null,
      selectServices: [],
    }
  },
  computed: {
    ...mapGetters({
      hasGmbStore: 'companiesCompany/hasGmbStore',
      hasYahooPlaceStore: 'companiesCompany/hasYahooPlaceStore',
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    mediaLibraryCategories: () => mediaLibraryCategoriesConst,
    mediaLibraryServices() {
      const services = []
      if (this.hasGmbStore) services.push(mediaLibraryServicesConst.find((service) => service.id === 'google_map'))
      if (this.hasYahooPlaceStore) services.push(mediaLibraryServicesConst.find((service) => service.id === 'yahoo_map'))
      return services
    },
    fileUploadUserName() {
      return this.selectMediaLibrary.fileUploadUser.lastName + ' ' + this.selectMediaLibrary.fileUploadUser.firstName
    },
    fileSize() {
      const size = this.selectMediaLibrary.fileSize
      return this.$t('models.mediaLibrary.fileSizePixel', { width: size.width, height: size.height })
    },
    uploadedTime() {
      return basicDateFormat(this.selectMediaLibrary.fileUploadedAt, this.$t('format.date.lang'))
    },
    submitButtonDisabled() {
      return !this.selectCategory || this.selectServices.length === 0
    },
    includesOnlyYahooMap() {
      return this.selectServices.length === 1 && this.selectServices.includes('yahoo_map')
    }
  },
  watch: {
    // yahoo_mapのみ選択している時に「自動判定」を選択できないように、選択していた場合解除する
    selectServices: {
      immediate: true,
      handler() {
        if (this.includesOnlyYahooMap && this.selectCategory === 'category_unspecified') {
          this.selectCategory = null
        }
      }
    }
  },
  methods: {
    ...mapActions({
      readStores: 'companiesGmbSearchStores/readStores'
    }),
    selectCategoryDisabled(categoryId) {
      return this.isNotOnlyOneCoverImage(categoryId) || this.disabledCategoryUnspecifiedIfOnlyYahoo(categoryId)
    },
    isNotOnlyOneCoverImage(categoryId) {
      return categoryId === 'cover' && this.mediaLibraryIds.length > 1
    },
    disabledCategoryUnspecifiedIfOnlyYahoo(categoryId) {
      return categoryId === 'category_unspecified' && this.includesOnlyYahooMap
    },
    handleChangeMediaLibraryIds(id){
      if (this.mediaLibraryIds.includes(id)) {
        this.mediaLibraryIds = this.mediaLibraryIds.filter(v => v !== id)
      } else {
        this.mediaLibraryIds = [...this.mediaLibraryIds, id]
      }
    },
    handleServiceCheckbox(serviceId) {
      if (this.selectServices.includes(serviceId)) {
        this.selectServices = this.selectServices.filter(v => v !== serviceId)
      } else {
        this.selectServices = [...this.selectServices, serviceId]
      }
    },
    handleCancelModal() {
      this.initModal()
      this.$emit('close')
    },
    initModal() {
      this.mediaLibraryIds = []
      this.isCategoryModal = false
      this.selectCategory = null
    },
    handleSelectCategory() {
      if (this.isNotOnlyOneCoverImage(this.selectCategory)) this.selectCategory = null
      this.isCategoryModal = true
    },
    async handleSubmit() {
      // カバー写真バリデーション
      if (this.selectCategory === 'cover') {
        if (this.isNotOnlyOneCoverImage(this.selectCategory)) {
          alert(this.$t('models.mediaLibraryStore.validation.isNotOnlyOneCoverImage'))
          return
        }
        const mediaLibrary = this.mediaLibraries.find(image => image.id === this.mediaLibraryIds[0])
        const { valid, errors } = await validate(mediaLibrary.mediaImageUrl, 'gmbCoverImage')
        if (!valid) {
          alert(errors[0])
          return
        }
      }

      this.$emit('submit', { mediaLibraryIds: this.mediaLibraryIds, selectServices: this.selectServices, selectCategory: this.selectCategory })
      this.initModal()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/biz_spa/foundation/_var.scss";
@import "../../../../stylesheets/biz_spa/foundation/_mixin.scss";
.p-modal {
  &__content {
    &__footer {
      padding: 12px 32px;
      border-top: 1px solid $color-base-c;
    }
    &__body {
      height: 70vh;
      overflow-y: hidden;
    }
    &__header {
      font-weight: normal;
    }
  }
}
.scrollable {
  overflow-y: auto;
}
.p-modal--filter {
  :deep(.p-modal__content) {
    width: 1360px;
  }
}
.p-photos {
  &__item {
    cursor: pointer;
    @include mq(xs) {
      width: calc(100% / 3);
    }
    @include mq(md) {
      width: calc(100% / 4);
    }
    @include mq(xl) {
      width: calc(100% / 5);
    }
  }
  &__image {
    padding-bottom: 80%;
  }
}
.c-checkbox {
  padding: 24px;
}
.mediaLibraries {
  height: 70vh;
  padding: 24px 12px 0 32px;
  overflow-x: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .3);
    background-color: rgba(0, 0, 50, .5);
  }
}
.store-count-wap {
  bottom: 5px;
}
.store-count {
  margin: 0 5px;
  color: $color-accent-primary;
  font-weight: 700;
  font-size: 30px;
}
.c-button__item:disabled {
  opacity: .3;
  cursor: auto;
}
.c-select {
  width: 30%;
  margin-bottom: 20px;
}
.mediaLibraryDetail {
  padding: 24px 24px 0;
  background: #F8F9FA;
}
.detail {
  &__container {
    margin-top: 24px;
  }
}
.value {
  &__list {
    margin-bottom: 24px;
  }
  &__item {
    padding: 2px;
  }
  &__text {
    font-weight: bold;
  }
}
.c-grid__items {
  margin: 0;
}
.categoryBox {
  margin-top: 24px;
  border: 1px solid #E4E7EB;
  &__header {
    padding: 24px 16px;
    background: #F8F9FA;
    border-bottom: 1px solid #E4E7EB;
  }
  &__title {
    font-weight: 700;
  }
  &__body {
    padding: 24px 16px;
  }
}
.c-radio__label::before {
  border: 1px solid #E2E2E2;
  background-color: #FFF;
}
.c-checkbox__label::before {
  background: #E2E2E2;
}
.noMediaLibraries {
  &__description {
    white-space: pre-wrap;
  }
}
.unselectable {
  cursor: not-allowed;
}
</style>
